import React from 'react';
import { useTranslation } from 'react-i18next';
import { isSameDay } from 'date-fns';

import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsTableRow from '../ManageContractsTableRow';

// Types.
import { Delivery } from '../../../../types/contract';

// Utils.
import { generateAddress } from '../../../../utils/address';
import { existingExtraServices, extraServicesAvailable } from '../../../../utils/contractManagement';

export const OldContract: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const { filteredContracts, filteredLedgers, selectedForm4, oldContract, useVaihtoturva } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepPrevContract">
      <h3>{t('manageContracts:manageContracts.SelectOldContractTitle')}*</h3>

      <div className="manage-contracts-table old-contract">
        <header className="manage-contracts-table-header">
          <div>{t('manageContracts:manageContracts.TableContract')}</div>
          <div>{t('common:general.contractNumber')}</div>
          <div>{t('billing:billing.sortContractType')}</div>
          <div>{t('manageContracts:manageContracts.TablePeriod')}</div>
        </header>
        {filteredContracts.map((contract) => {
          const contractHasVaihtoturva = contract.activeDeliveries?.find((d) => d.elementName.toLowerCase().includes('vaihtoturva')) ? true : false;

          let filteredDeliveries: Delivery[] = [];
          if (contract.activeDeliveries) {
            filteredDeliveries = contract.activeDeliveries.filter(
              (d) => !(d.elementName.toLowerCase().includes('vaihtoturva') || d.elementName.toLowerCase().includes('hyvitys')),
            );
          }

          if (contract.activeDeliveries) {
            if (
              selectedForm4 === 3 &&
              !extraServicesAvailable(contract.activeDeliveries) &&
              existingExtraServices(contract.activeDeliveries).length === 0
            ) {
              return false;
            }
          }

          const contractLedgerPaymentTypeNo = filteredLedgers.find((l) => l.ledgerNo === contract.ledgerNo)?.paymentType?.paymentTypeNo;

          if (selectedForm4 === 2 && (contractLedgerPaymentTypeNo === 20 || contractLedgerPaymentTypeNo === 3)) {
            return false;
          }

          const lastSpotPriceFix = contract?.deliveries
            ?.sort((a, b) => (new Date(a.specialToDate || new Date()) < new Date(b.specialToDate || new Date()) ? 1 : -1))
            .filter((d) => d.elementNo === 10 && !isSameDay(new Date(d.specialToDate || new Date()), new Date('2073-06-01')))[0];

          const lastSpotPriceFixEndDate =
            new Date(lastSpotPriceFix?.specialToDate || new Date()) > new Date() ? lastSpotPriceFix?.specialToDate : undefined;

          if (contract.meteringPoint) {
            return (
              <ManageContractsTableRow
                key={contract.contractCode}
                newContract={false}
                contractNo={contract.contractCode}
                selected={oldContract?.contractCode === contract.contractCode}
                contractEndDate={
                  lastSpotPriceFixEndDate ??
                  (filteredDeliveries.length > 0 && filteredDeliveries[0].tariffToDate ? filteredDeliveries[0].tariffToDate : contract.endDate)
                }
                contractTitle={generateAddress(contract.meteringPoint, false)}
                contractName={
                  filteredDeliveries.length > 0 && filteredDeliveries[0].externalName
                    ? filteredDeliveries[0].externalName
                    : t('manageContracts:manageContracts.TableContract')
                }
                contractNumber={contract.contractCode}
                contractExtraServices={
                  selectedForm4 === 3 && contract.activeDeliveries ? existingExtraServices(contract.activeDeliveries) : undefined
                }
                contractHasPaperBilling={!(contractLedgerPaymentTypeNo === 3 || contractLedgerPaymentTypeNo === 20)}
                contractHasVaihtoturva={selectedForm4 === 1 ? contractHasVaihtoturva : false}
                useVaihtoturva={useVaihtoturva}
              />
            );
          }
          return false;
        })}
        <footer className="manage-contracts-table-footer">{t('consumption:consumption:theseIncTax')}</footer>
      </div>
    </section>
  );
};

export default OldContract;
